import { useState } from 'react';
import { NavBar } from '../../components/navBar.tsx';
import { Tool } from '../../components/operation-dialog/operationDraft.ts';
import { PageTitle } from '../../components/pageTitle.tsx';
import { Batch, Operation } from '../../types/sharedTypeImpl.ts';
import { BrokenToolOperations } from './brokenToolOperations.tsx';
import { BrokenToolsPerBatch } from './brokenToolsPerBatch.tsx';
import { BrokenToolsPerTool } from './brokenToolsPerTool.tsx';


export function BrokenTools() {
    const [selectedBatch, setSelectedBatch] = useState<Batch | null>(null);
    const [selectedBatchOps, setSelectedBatchOps] = useState<Operation[] | null>(null);
    const [selectedTool, setSelectedTool] = useState<Tool | null>(null);
    const [selectedToolOps, setSelectedToolOps] = useState<Operation[] | null>(null);

    const handleBatchSelected = (batch: Batch, batchOps: Operation[]) => {
        setSelectedBatch(batch);
        setSelectedBatchOps(batchOps);
        setSelectedTool(null);
        setSelectedToolOps(null);
    };

    const handleToolSelected = (tool: Tool, toolOps: Operation[]) => {
        setSelectedTool(tool);
        setSelectedToolOps(toolOps);
    };

    return (
        <>
            <PageTitle title='Broken Tools' />
            <NavBar />
            <div className='content' style={{ maxWidth: '1280px' }}>
                <BrokenToolsPerBatch
                    selectedBatch={selectedBatch}
                    onBatchSelected={handleBatchSelected}
                />

                {selectedBatch && (
                    <BrokenToolsPerTool
                        batch={selectedBatch}
                        batchOperations={selectedBatchOps!}
                        selectedTool={selectedTool}
                        onToolSelected={handleToolSelected}
                    />
                )}

                {selectedToolOps && (
                    <BrokenToolOperations
                        batch={selectedBatch!}
                        toolOperations={selectedToolOps}
                    />
                )}
            </div>
        </>
    );
}
